import React from 'react';
import { Drawer, Modal } from 'antd';

const DrawerModal = ({ mode = 'drawer', children, onClose, ...rest }) => {
  if (mode === 'drawer') {
    return (
      <Drawer onClose={onClose} {...rest}>
        {children}
      </Drawer>
    );
  }

  if (mode === 'modal') {
    return (
      <Modal onCancel={onClose} {...rest}>
        {children}
      </Modal>
    );
  }

  return null;
};

export default DrawerModal;
